import jwt from 'jsonwebtoken';

let isLoggingOut = false;
let onSessionExpired = null;

export function registerSessionExpiredHandler(handler) {
    onSessionExpired = handler;
}

export function decodeToken(token) {
    if (!token) return null;
    try {
        return jwt.decode(token);
    } catch {
        return null;
    }
}

export function isTokenExpired(token) {
    const decoded = decodeToken(token);
    if (!decoded?.exp) return true;
    return decoded.exp * 1000 <= Date.now();
}

export function getTokenExpiryMs(token) {
    const decoded = decodeToken(token);
    if (!decoded?.exp) return 0;
    return decoded.exp * 1000;
}

function getResponseMessage(data) {
    if (typeof data === 'string') return data;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    return '';
}

export function isUnauthorizedResponse(error) {
    const status = error?.response?.status;
    if (status === 401) return true;
    if (status === 409) {
        return getResponseMessage(error.response?.data) === 'Unauthorized';
    }
    return false;
}

export function clearAuthStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('id');
    localStorage.removeItem('hasFutures');
    localStorage.removeItem('paymentDetails');
}

export function logoutSession({ redirect = true, redirectTo = '/login' } = {}) {
    if (isLoggingOut) return;
    isLoggingOut = true;

    clearAuthStorage();

    if (onSessionExpired) {
        onSessionExpired();
    }

    if (!redirect) {
        isLoggingOut = false;
        return;
    }

    const { pathname } = window.location;
    if (pathname !== redirectTo && pathname !== '/') {
        window.location.href = redirectTo;
    } else if (pathname === '/') {
        window.location.reload();
    } else {
        isLoggingOut = false;
    }
}